import Glide from '@glidejs/glide';

const glideElement = document.querySelector('.glide-store-slidy');
if (glideElement) {
  new Glide('.glide-store-slidy', {
    type: 'carousel',
    autoplay: 14000,
    perView: 1.15,
    focusAt: 'center',
  }).mount();
}

const glideMobileElement = document.querySelector('.glide-store-mobile-slidy');
if (glideMobileElement) {
  new Glide('.glide-store-mobile-slidy', {
    type: 'carousel',
    autoplay: 14000,
    perView: 1,
    focusAt: 'center',
  }).mount();
}